import React from 'react';
import { useTranslation } from 'react-i18next';
import { BookOpen } from 'lucide-react';
import ComponentLibrary from '../../features/misc/ComponentLibrary/ComponentLibrary';
import OCELFileManager from '../../features/file-manager/OCELFileManager/OCELFileManager';
import { GlobalFilterPanel } from '../../features/filter';
import HideInWorkshop from '../common/HideInWorkshop';
import LanguageSwitcher from '../common/LanguageSwitcher';

const ToolbarButtons = ({ activeFile, onFileChange, onDisplayNameChange, onComponentAdd, onOpenConfigManager, allowedComponentIds }) => {
  const { t } = useTranslation('common');

  return (
    <div className="fixed top-4 right-4 z-50 flex gap-3 items-center">
      {/* Hidden in workshop mode like the other admin controls: language is a
          one-off setup choice, not something customers should self-serve —
          they tell us if they want a different one. */}
      <HideInWorkshop>
        <LanguageSwitcher />
      </HideInWorkshop>

      <HideInWorkshop>
        <button
          onClick={onOpenConfigManager}
          title={t('toolbar.configManagerTooltip')}
          className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-lg shadow-md hover:shadow-lg transition-shadow"
        >
          <BookOpen className="w-5 h-5" />
          <span>{t('toolbar.configs')}</span>
        </button>
      </HideInWorkshop>

      <GlobalFilterPanel activeFile={activeFile} disableFixedPositioning={true} />

      <HideInWorkshop>
        <OCELFileManager
          activeFile={activeFile}
          onFileChange={onFileChange}
          onDisplayNameChange={onDisplayNameChange}
          disableFixedPositioning={true}
        />
      </HideInWorkshop>

      <HideInWorkshop>
        <ComponentLibrary
          onComponentAdd={onComponentAdd}
          disableFixedPositioning={true}
          allowedComponentIds={allowedComponentIds}
        />
      </HideInWorkshop>
    </div>
  );
};

export default ToolbarButtons;
